export class SharedConstants {
    public static readonly OTHER_PRODUCTS_TYPE: string = "ALTRO_PRODOTTO";
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/models/constants/shared-constants.ts